'use client';

import { Category } from '@eliadmin/core/src/api/slugs/types/slug-detail-types';
import { HtmlDescription } from '@eliadmin/core/src/components/ui/html-description';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useRef, useState, useLayoutEffect } from 'react';

const LINE_HEIGHT = 24;
const MAX_LINES = 3;
const MAX_HEIGHT = LINE_HEIGHT * MAX_LINES;

export function CategoryDescription({ category }: { category: Category }) {
  const { t } = useTranslations();
  const contentRef = useRef<HTMLDivElement>(null);
  const [expanded, setExpanded] = useState(false);
  const [needsToggle, setNeedsToggle] = useState(false);
  const [fullHeight, setFullHeight] = useState<number | undefined>(undefined);

  useLayoutEffect(() => {
    const el = contentRef.current;
    if (!el) return;
    const h = el.scrollHeight;
    setFullHeight(h);
    setNeedsToggle(h > MAX_HEIGHT);
  }, [category?.description]);

  if (!category?.description) return null;

  return (
    <div className="w-full">
      <div
        style={{
          maxHeight: needsToggle && !expanded ? MAX_HEIGHT : fullHeight ?? 'none',
          overflow: 'hidden',
          transition: 'max-height 0.4s ease',
        }}
      >
        <div ref={contentRef}>
          <HtmlDescription
            size="base"
            className="w-full"
            color="foreground"
            content={category.description}
          />
        </div>
      </div>

      {needsToggle && (
        <button
          onClick={() => setExpanded(e => !e)}
          className="mt-2 text-sm font-medium text-primary hover:underline focus:outline-none"
        >
          {expanded ? t('text604') : t('text338')}
        </button>
      )}
    </div>
  );
}
